import React, {useState} from 'react';
import {Song} from '../../../../../types';
import {ItemTable, HeaderOption} from '../../../../ItemTable';
import {Heart} from '../../../components';
import {LikeButton} from '../LikeButton';
import {useMutation} from '@apollo/client';
import {LIKE_SONG_MUTATION} from './graphql';
import {stringFilter} from '../utilities';
import styles from './SongList.module.scss';

export type SongListTypes = 'album' | 'playlist' | 'song';

interface Props {
  songs: Song[];
  onSelect(song: Song): void;
  type: SongListTypes;
  ordered?: boolean;
}

export function SongList({songs, onSelect, type, ordered}: Props) {
  const [searchFilter, setSearchFilter] = useState('');
  const [likeSong] = useMutation(LIKE_SONG_MUTATION);

  const filteredSongs = stringFilter(songs, {
    filterValue: searchFilter,
    attributesToFilterOn: ['name'],
  });

  const onToggleLike = (song: Song) => async (liked: boolean) => {
    liked
      ? likeSong({variables: {songId: song.id}})
      : likeSong({variables: {songId: song.id}}); // TODO: Update with unlike song mutation once added
  };

  const commonHeaders: HeaderOption[] = [
    {
      label: 'Title',
      onClick: () => {
        console.log('Clicked Title Header');
        // Adjust filter to sort by title
      },
    },
    {
      label: 'Artist',
      onClick: () => {
        console.log('Clicked Artist Header');
        // Adjust filter to sort by artist
      },
    },
    {
      label: <Heart label size="medium" />,
    },
  ];

  const pickHeaders = () => {
    if (type === 'album') {
      return [
        {
          label: '#',
          onClick: () => {
            console.log('Clicked # Header');
          },
        },
        ...commonHeaders,
      ];
    } else {
      // Playlist or Library Song List
      return commonHeaders;
    }
  };

  const headers = pickHeaders();

  function songValuePicker(song: Song) {
    if (type === 'album') {
      return [
        song.trackNumber,
        song.name,
        song.artistName,
        <LikeButton liked onToggleLike={onToggleLike(song)} />,
      ];
    } else {
      // Playlist or Library Song List
      return [
        song.name,
        song.artistName,
        <LikeButton liked onToggleLike={onToggleLike(song)} />,
      ];
    }
  }

  return (
    <>
      <div className={styles.FilterSection}>
        <input
          className={styles.Filter}
          placeholder="Filter"
          onChange={(event) => setSearchFilter(event.target.value)}
        />
      </div>
      <ItemTable<Song>
        headers={headers}
        itemValuePicker={songValuePicker}
        items={filteredSongs}
        onSelect={onSelect}
        ordered={ordered}
      />
    </>
  );
}
